<mat-card>
  <mat-card-title class="custom-title">{{ "Start" }} Match</mat-card-title>
  <mat-card-content>
    <p class="match-description">{{ displayTotalPairs }} total pairs. With {{ displayActiveConfirmedPairs }} participating, enis sync needed: {{ displayEnisSyncCount }}, {{ displayActivePairs }} active and {{ displayInactivePairs }} inactive.</p>

    <!-- Warning banner for participant issues -->
    <div class="warning-banner" *ngIf="participantWarnings && !participantWarnings.canStartMatchrun">
      <div class="warning-header">
        <mat-icon class="warning-icon">warning</mat-icon>
        <h3>Cannot Start Matchrun</h3>
      </div>
      <p class="warning-message">{{ participantWarnings.message }}</p>
      <div class="warning-details" *ngIf="participantWarnings.participants && participantWarnings.participants.length > 0">
        <button mat-button color="warn" (click)="showWarningDetails()">
          View Details ({{ participantWarnings.participants.length }} participant{{ participantWarnings.participants.length > 1 ? 's' : '' }})
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions *ngIf="checkedLoading" fxLayout="row" class="actions-container" [ngStyle]="loading ? { 'justify-content': 'center' } : {}">
    <div fxFlex fxFlexFill></div>

    <div class="button-container" *ngIf="!loading && canStartMatchrun">
      <button
        mat-raised-button
        color="primary"
        (click)="startMatchrun()"
        [disabled]="participantWarnings && !participantWarnings.canStartMatchrun">
        Start match
      </button>
    </div>
    <div class="permission-message" *ngIf="!loading && !canStartMatchrun">
      <p>You don't have permission to start match runs. Contact your administrator if you need access.</p>
    </div>
    <div class="loading-container" *ngIf="loading" style="justify-content: center">
      <mat-spinner diameter="30"></mat-spinner>
      <p>{{ statusMessage }}</p>
    </div>
  </mat-card-actions>
</mat-card>

<a *ngIf="latestMatchrun" mat-list-item [href]="'/matchrun/' + currentMatchingPeriodId + '/' + latestMatchrun"> See latest match run </a>
<span *ngIf="!latestMatchrun" mat-list-item> No match runs yet for this period </span>
